"use client";

import { Button } from "@/intent-components/ui/button";
import { Loader } from "@/intent-components/ui/loader";
import { startTransition, useOptimistic } from "react";
import { submitJob } from "./submit-job.action";
import { IconPlay } from "@intentui/icons";

export function RunJobButton({
  isRunning,
  configurationId,
}: {
  isRunning: boolean;
  configurationId: number;
}) {
  const [optimisticIsRunning, setOptimisticIsRunning] =
    useOptimistic(isRunning);

  async function handleClick() {
    startTransition(() => {
      setOptimisticIsRunning(true);

      submitJob({
        configurationId,
      });
    });
  }

  return (
    <Button
      className="w-full"
      onPress={handleClick}
      isDisabled={optimisticIsRunning}
    >
      {optimisticIsRunning ? <Loader /> : <IconPlay />}
      {optimisticIsRunning ? "Running..." : "Run"}
    </Button>
  );
}
